import styled from 'styled-components'

export const AccordionItem = styled.div`
  width: 100%;
`

export const Header = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`

export const AccordionButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  color: var(--theme-primary);
  display: flex;
  font-size: 26px;
  justify-content: center;
  padding-bottom: 5px;
`
